import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { fmt, badge, zebra } from '../../lib/format';
import { card, Th, Chip } from '../../lib/ui';

export default function Invoice() {
  const { go, L } = useApp();

  const invKpis = [
    { label: L('Total POs', 'PO ทั้งหมด'), value: '10', color: 'var(--color-fg-1)' },
    { label: L('Matched', 'จับคู่แล้ว'), value: '6', color: 'var(--color-success)' },
    { label: L('Variance', 'ส่วนต่าง'), value: '1', color: 'var(--color-error)' },
    { label: L('In Progress', 'กำลังดำเนินการ'), value: '3', color: 'var(--color-warning)' },
  ];
  const invData = [
    { id: 'PO-2026-0041', desc: 'Fleet Vehicle Insurance — Class 1', sup: 'Apex Insurance Co.', value: 4620000, gr: 'GR-2026-0031', grOk: true, inv: 'INV-2026-0063', match: 'Variance' },
    { id: 'PO-2026-0031', desc: 'Maintenance Services — Factory Equipment', sup: 'Crestline Insurance', value: 2050000, gr: 'GR-2026-0028', grOk: true, inv: 'INV-2026-0055', match: 'Matched' },
    { id: 'PO-2026-0035', desc: 'Spare Parts — Q2 Batch', sup: 'ACME Union Motors Ltd.', value: 12100000, gr: '', grOk: false, inv: '', match: 'Pending GR' },
    { id: 'PO-2026-0047', desc: 'Property All-Risk Insurance', sup: 'Apex Insurance Co.', value: 5400000, gr: '', grOk: false, inv: '', match: 'Pending' },
  ];
  const invRows = invData.map((r, i) => {
    const m = badge(r.match), g = badge(r.grOk ? 'Verified' : 'Pending');
    return {
      ...r,
      value: fmt(r.value),
      zebra: zebra(i),
      mBg: m.bg,
      mFg: m.fg,
      grBg: g.bg,
      grFg: g.fg,
      grText: r.gr || L('Pending', 'กำลังรอ'),
      invText: r.inv || L('Not Received', 'ยังไม่ได้รับ'),
      matchIcon: r.match === 'Matched' ? 'check' : r.match === 'Variance' ? 'alert-triangle' : 'clock',
    };
  });

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {invKpis.map((k) => (
          <div key={k.label} style={{ ...card, padding: '16px 18px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 26, fontWeight: 700, fontFamily: 'var(--font-mono)', color: k.color }}>{k.value}</div>
          </div>
        ))}
      </div>
      <div style={{ ...card, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 900 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('PO Number', 'เลขที่ PO')}</Th>
              <Th>{L('Description', 'รายละเอียด')}</Th>
              <Th>{L('Supplier', 'ซัพพลายเออร์')}</Th>
              <Th align="right">{L('PO Value', 'มูลค่า PO')}</Th>
              <Th>{L('Goods Receipt', 'ใบรับสินค้า')}</Th>
              <Th>{L('Invoices', 'ใบแจ้งหนี้')}</Th>
              <Th>{L('3-Way Match', 'การจับคู่ 3 ทาง')}</Th>
              <Th align="right">{L('Actions', 'การดำเนินการ')}</Th>
            </tr>
          </thead>
          <tbody>
            {invRows.map((r) => (
              <tr key={r.id} style={{ borderBottom: '1px solid var(--color-border)', background: r.zebra }}>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.id}</td>
                <td style={{ padding: '12px 14px' }}>{r.desc}</td>
                <td style={{ padding: '12px 14px', color: 'var(--color-fg-2)' }}>{r.sup}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.value}</td>
                <td style={{ padding: '12px 14px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: r.grBg, color: r.grFg, fontFamily: 'var(--font-mono)' }}>{r.grText}</span></td>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--color-fg-2)' }}>{r.invText}</td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: r.mBg, color: r.mFg }}>
                    <Icon name={r.matchIcon} style={{ fontSize: 12 }} />{r.match}
                  </span>
                </td>
                <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                  <button onClick={() => go('match')} className="hv-blue" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-blue)', color: '#fff' }}>{L('View', 'ดู')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
